import { getApp, initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import api from "./api";

const VAPID_KEY = process.env.REACT_APP_FIREBASE_VAPID_KEY;

/* Push runs on its own Firebase app instance. This is public web config (safe to
   expose by design) but sourced from env so project swaps stay in one place. */
const PUSH_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_PUSH_APP_ID,
};

function pushApp() {
  try { return getApp("push"); } catch { return initializeApp(PUSH_CONFIG, "push"); }
}

export const pushSupported = () =>
  "serviceWorker" in navigator && "Notification" in window && Boolean(VAPID_KEY);

export async function enablePush() {
  if (!("serviceWorker" in navigator) || !("Notification" in window)) {
    throw new Error("This browser does not support push notifications.");
  }
  if (!VAPID_KEY) {
    throw new Error("Push is not configured yet (missing VAPID key).");
  }
  const permission = await Notification.requestPermission();
  if (permission !== "granted") throw new Error("Notification permission denied.");
  const messaging = getMessaging(pushApp());
  const reg = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
  const token = await getToken(messaging, { vapidKey: VAPID_KEY, serviceWorkerRegistration: reg });
  if (!token) throw new Error("Could not obtain a push token.");
  await api.post("/push/register", { token });
  onMessage(messaging, (payload) => {
    const n = payload.notification || {};
    if (Notification.permission === "granted") {
      new Notification(n.title || "TravelerPulse", { body: n.body || "" });
    }
  });
  return token;
}
